import PropTypes from 'prop-types';
import { BsCheckCircleFill, BsCircle } from 'react-icons/bs';

const STAGES = [
	{ key: 'strategy', label: 'Vertriebsstrategie entwerfen', statusCheck: (g) => g?.status === 'completed' },
	{
		key: 'searching',
		label: 'Passende Leads suchen',
		statusCheck: (g) => g?.leadSearchStatus === 'completed',
	},
];

function getCurrentStageIndex(generation) {
	if (!generation) return 0;
	if (generation.status !== 'completed') return 0;
	if (!generation.leadSearchStatus || generation.leadSearchStatus === 'pending') return 0;
	if (generation.leadSearchStatus === 'searching') return 1;
	return 1;
}

const OnboardingProgress = ({ generation, elapsedSec = 0 }) => {
	const currentIdx = getCurrentStageIndex(generation);

	return (
		<div className="flex flex-col items-center justify-center py-10 sm:py-16 space-y-6 sm:space-y-8">
			<div className="h-12 w-12 sm:h-16 sm:w-16 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">
				<svg className="animate-spin h-6 w-6 sm:h-8 sm:w-8" viewBox="0 0 24 24" fill="none">
					<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
					<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
				</svg>
			</div>

			<div className="text-center">
				<h3 className="text-lg font-semibold text-text mb-1">Ihre Vertriebsstrategie wird erstellt …</h3>
				<p className="text-sm text-bgBase-800">
					{elapsedSec < 45
						? 'Gleich sehen Sie Ihre Strategie und die ersten Leads.'
						: 'Fast geschafft — die KI arbeitet noch an den Details.'}
				</p>
			</div>

			<div className="w-full max-w-sm space-y-3">
				{STAGES.map((stage, idx) => {
					const isDone = stage.statusCheck(generation);
					const isActive = idx === currentIdx && !isDone;

					return (
						<div key={stage.key} className="flex items-center gap-3">
							{isDone ? (
								<BsCheckCircleFill className="w-5 h-5 text-success-500 flex-shrink-0" />
							) : isActive ? (
								<div className="w-5 h-5 flex-shrink-0 flex items-center justify-center">
									<div className="w-3 h-3 rounded-full bg-primary-500 animate-pulse" />
								</div>
							) : (
								<BsCircle className="w-5 h-5 text-bgBase-800 flex-shrink-0" />
							)}
							<span
								className={`text-sm ${isDone ? 'text-success-700 font-medium' : isActive ? 'text-text font-medium' : 'text-bgBase-800'}`}
							>
								{stage.label}
							</span>
						</div>
					);
				})}
			</div>
		</div>
	);
};

OnboardingProgress.propTypes = {
	generation: PropTypes.object,
	elapsedSec: PropTypes.number,
};

export default OnboardingProgress;
